import { httpsCallable } from 'firebase/functions';
import { FirebaseError } from 'firebase/app';
import { useAppDispatch, useAppSelector } from '../../../../../hooks';
import { functions } from '../../../../../config/firebase';
import {
    setFormDataReducer,
    submitRegistrationFailureReducer,
    submitRegistrationStartReducer,
    submitRegistrationSuccessReducer,
    clearRegistrationErrorReducer,
    resetRegistrationStateReducer
} from '../slice/SearchMyNetworkSlice';
import {
    SearchMyNetworkFormInterface,
    ResponseSearchMyNetworkInterface
} from '../../domain';

const useSearchMyNetworkInfrastructure = () => {
    const dispatch = useAppDispatch();
    const searchMyNetworkState = useAppSelector(state => state.myNetwork);

    const getReferralMyNetworkByPhoneCallable = httpsCallable<SearchMyNetworkFormInterface, ResponseSearchMyNetworkInterface>(functions, 'getAllReferrals');


    const setFormDataInfrastructure = (formData: Partial<SearchMyNetworkFormInterface>) => {
        dispatch(setFormDataReducer(formData));
    }

    const submitRegistrationInfrastructure = async () => {
        dispatch(submitRegistrationStartReducer());
        try {
            // El SDK de Firebase envuelve esto en un objeto { data: ... } automáticamente.
            // No necesitamos hacerlo nosotros.
            const result = await getReferralMyNetworkByPhoneCallable(searchMyNetworkState.formData);
            dispatch(submitRegistrationSuccessReducer(result.data));
            return result.data;
        } catch (error) {
            console.error("Error al buscar la red de referidos:", error);
            if (error instanceof FirebaseError) {
                dispatch(submitRegistrationFailureReducer(error.message));
            } else {
                dispatch(submitRegistrationFailureReducer('Ocurrió un error inesperado.'));
            }
        }
    };

    const clearRegistrationErrorInfrastructure = () => {
        dispatch(clearRegistrationErrorReducer());
    }

    const resetRegistrationStateInfrastructure = () => {
        dispatch(resetRegistrationStateReducer());
    }


    return {
        setFormDataInfrastructure,
        submitRegistrationInfrastructure,
        clearRegistrationErrorInfrastructure,
        resetRegistrationStateInfrastructure,
        searchMyNetworkState
    }
}

export default useSearchMyNetworkInfrastructure;